export const AnalyseConstants = {
    REQUEST_SAVE_TEAM_STASH: 'REQUEST_SAVE_TEAM_STASH',
    RECEIVE_SAVE_TEAM_STASH: 'RECEIVE_SAVE_TEAM_STASH',

    REQUEST_SAVE_TEAM_DETAIL: 'REQUEST_SAVE_TEAM_DETAIL',
    RECEIVE_SAVE_TEAM_DETAIL: 'RECEIVE_SAVE_TEAM_DETAIL',
    // SAVE_TEAM_DETAIL_ERROR: 'SAVE_TEAM_DETAIL_ERROR',

    RECEIVE_SAVE_MODULE_DETAIL:'RECEIVE_SAVE_MODULE_DETAIL',
    REQUEST_SAVE_MODULE_DETAIL:'REQUEST_SAVE_MODULE_DETAIL',

    REQUEST_ASSESSOR_GROUPS:'REQUEST_ASSESSOR_GROUPS',
    RECEIVE_ASSESSOR_GROUPS:'RECEIVE_ASSESSOR_GROUPS',
    ASSESSOR_GROUPS_ERROR:'ASSESSOR_GROUPS_ERROR',

    REQUEST_TEAM_ID_GROUPS:'REQUEST_TEAM_ID_GROUPS',
    RECEIVE_TEAM_ID_GROUPS:'RECEIVE_TEAM_ID_GROUPS',
    TEAM_ID_GROUPS_ERROR:'TEAM_ID_GROUPS_ERROR',

    REQUEST_SAVE_ASSESOR_GROUPS:'REQUEST_SAVE_ASSESOR_GROUPS',
    RECEIVE_SAVE_ASSESOR_GROUPS:'RECEIVE_SAVE_ASSESOR_GROUPS',

    REQUEST_SAVE_ASSESOR_IDS:'REQUEST_SAVE_ASSESOR_IDS',
    RECEIVE_SAVE_ASSESOR_IDS:'RECEIVE_SAVE_ASSESOR_IDS',

}



// WEBPACK FOOTER //
// ./src/_constants/Analyse/analyse.constants.js